import { IState } from '../../store';

export const selectBuilderStats = (state: IState) => {
  return state.offerData.company?.stats || null;
};
